import { render, staticRenderFns } from "./CompletedLoans.vue?vue&type=template&id=41db76f4"
import script from "./CompletedLoans.vue?vue&type=script&lang=js"
export * from "./CompletedLoans.vue?vue&type=script&lang=js"
import style0 from "./CompletedLoans.vue?vue&type=style&index=0&id=41db76f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports